import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/membership',
    name: 'membership',
    component: () => import('../views/MembershipView.vue')
  },
  {
    path: '/menuitems',
    name: 'menuitems',
    component: () => import('../views/MenuItemsView.vue')
  },
  {
    path: '/employeefiles',
    name: 'employeefiles',
    component: () => import('../views/EmployeeFilesView.vue')
  },
  {
    path: '/coachschedule',
    name: 'coachschedule',
    component: () => import('../views/CoachScheduleView.vue')
  },
  {
    path: '/coachattendance',
    name: 'coachattendance',
    component: () => import('../views/CoachAttendanceView.vue')
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import('../views/RolesView.vue')
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/UsersView.vue')
  },
  {
    path: '/class',
    name: 'class',
    component: () => import('../views/ClassView.vue')
  },
  {
    path: '/merchandiseproduct',
    name: 'merchandiseproduct',
    component: () => import('../views/MerchandiseProductView.vue')
  },
  {
    path: '/pos',
    name: 'pos',
    component: () => import('../views/POSView.vue')
  },
  {
    path: '/physicalcount',
    name: 'physicalcount',
    component: () => import('../views/PhysicalCountView.vue')
  },
  {
    path: '/discount',
    name: 'discount',
    component: () => import('../views/DiscountView.vue')
  },
  {
    path: '/coachduty',
    name: 'coachduty',
    component: () => import('../views/CoachDutyView.vue')
  },
  {
    path: '/merchandiseproductgroup',
    name: 'merchandiseproductgroup',
    component: () => import('../views/MerchandiseProductGroupView.vue')
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/reports/MembershipMonitoringView.vue')
  },
  {
    path: '/dailysales',
    name: 'dailysales',
    component: () => import('../views/reports/DailySalesView.vue')
  },
  {
    path: '/inventoryreport',
    name: 'inventoryreport',
    component: () => import('../views/reports/InventoryReportView.vue')
  },
  {
    path: '/ptreport',
    name: 'ptreport',
    component: () => import('../views/reports/PTReportView.vue')
  },
  {
    path: '/classreport',
    name: 'classreport',
    component: () => import('../views/reports/ClassReportView.vue')
  },
  
]

const router = new VueRouter({
  routes
})

export default router
